import React from 'react';
import { motion } from 'framer-motion';
import { Eye, UserCheck, Wrench, Headphones, Building2 } from 'lucide-react';
const reasons = [{
  icon: Eye,
  title: 'Enfoque transparente',
  description: 'No hay sorpresas ni cargos ocultos. Todo es claro desde el principio.'
}, {
  icon: UserCheck,
  title: 'Sin presión de ventas',
  description: 'Consultamos, no vendemos. Tu mejor interés es nuestra prioridad.'
}, {
  icon: Wrench,
  title: 'Soluciones para tu negocio',
  description: 'POS, terminales, integración a medida según tus necesidades.'
}, {
  icon: Headphones,
  title: 'Soporte local en español',
  description: 'Equipo dedicado que habla tu idioma y entiende tu cultura.'
}, {
  icon: Building2,
  title: 'Diseñado para negocios establecidos',
  description: 'Trabajamos con empresas serias que procesan $30K+/mes.'
}];
export function WhyChooseSection() {
  return <section className="bg-navy text-white py-16 md:py-24" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-131">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4" data-id="element-132">
            ¿Por Qué Elegirnos?
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-133">
            Nos diferenciamos por nuestra honestidad y compromiso con tu éxito
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-134">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-lg hover:bg-opacity-20 transition-all" data-id="element-135">
                <div className="w-12 h-12 bg-gold bg-opacity-20 rounded-lg flex items-center justify-center mb-4" data-id="element-136">
                  <Icon className="text-gold" size={24} data-id="element-137" />
                </div>
                <h3 className="text-xl font-semibold mb-2" data-id="element-138">{reason.title}</h3>
                <p className="text-gray-300" data-id="element-139">{reason.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}